export const statusChipStyles = {
	info: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'nowrap',
		alignItems: 'center',
		gap: 1,
		height: '100%',
		width: '100%'
	},
	icon: {
		color: 'text.secondary'
	}
};
